import React from "react";
import classes from './siteButton.module.css';

const BtnDownload = (props) => {
    return(
        <a href={props.url} type="button" className={classes.btnDownload} download>{props.title}</a>
    )
}

export default BtnDownload;